function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const images = importAll(
  require.context(
    "../styles/images/brand-images",
    false,
    /\.(png|jpe?g|svg|jfif)$/
  )
);

const BrandImages = () => {
  const imageNames = Object.keys(images);

  return (
    <div id="brands">
      <h2 className="brand-images__title">Οι μάρκες μας</h2>
      <div className="brand-images__image-container">
        {imageNames.map((imageName, index) => {
          return (
            <img
              className="brand-images__image"
              src={images[imageName]}
              alt="brand logo"
              key={`brand-image-${index}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BrandImages;
